import { render } from "./HeroiconsSolidArrowCircleDown.vue?vue&type=template&id=3938d236"
const script = {}

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowCircleDown.vue"]])

export default __exports__